import update from 'immutability-helper'

export function extractStrings(input) {
  let output = []

  if (typeof input === 'string') {
    output.push(input)
  } else
  if (typeof input === 'object') {
    for (let i in input) {
      output = output.concat(extractStrings(input[i]))
    }
  }

  return output
}

export function capitalize(string) {
  string = string.replace(/\b\w/g, l => l.toUpperCase())

  return string
}

export function reorder(list, startIndex, endIndex) {
  const result = Array.from(list)
  const [removed] = result.splice(startIndex, 1)
  result.splice(endIndex, 0, removed)

  return result
}

export function getMonitorValue(item) {
  return item.value || item.member ? `${item.value || item.member.name} (${item.title})` : item.title
}

export function calculateColorNumber(position, maxNumbers) {
  const multiplier = Math.floor(position/maxNumbers)
  const number = position-(multiplier*maxNumbers)

  return number+1
}

export function hiddenInPaging(paging, index) {
  const offset = paging.stickyColumn && paging.hideFirstColumn ? paging.offset+1 : paging.offset
  const size = paging.stickyColumn ? paging.size-1 : paging.size

  if (offset > index || index >= (offset+size)) return true
  return false
}

export function getAvailableColumnTypes(columns, equipmentTypes) {
  const availableColumnTypes = [...equipmentTypes]

  columns.forEach((column, index) => {
    const columnIndex = availableColumnTypes.map(equipmentType => equipmentType.title).indexOf(column.title)

    if (columnIndex !== -1) availableColumnTypes.splice(columnIndex, 1)
  })

  return availableColumnTypes
}

export function getAvailableEquipmentTypes(columns, items) {
  let availableEquipmentTypes = {
    objects: [],
    ids: []
  }

  if (columns) {
    columns.forEach(column => {
      if (column.type !== 'instrument') {
        const itemIndex = items.map(item => item.type && item.type.slug).indexOf(column.type)
        const customItemIndex = column.type === 'custom' ? items.map(item => item.params && item.params.columnId).indexOf(column.id) : null

        if (customItemIndex === -1 || itemIndex === -1) {
          availableEquipmentTypes = update(availableEquipmentTypes, {
            objects: {
              $push: [{
                id: column.id,
                title: column.title,
                type: {
                  title: column.title,
                  slug: column.type
                },
                params: column.type === 'custom' ? {columnId: column.id} : null
              }]
            }
          })

          availableEquipmentTypes = update(availableEquipmentTypes, {
            ids: {
              $push: [column.type]
            }
          })
        }
      }
    })
  }

  return availableEquipmentTypes
}

export function getStageElementsByTypes(types = [], elements) {
  let stageElements = undefined

  if (elements) {
    stageElements = []

    types.forEach((type, index) => {
      if (elements[type]) {
        const element = Array.isArray(elements[type]) ? elements[type] : [elements[type]]

        stageElements = [...stageElements, ...element]
      }
    })
  }

  return stageElements
}

export function validateSearchResults(stageElements) {
  const { search } = stageElements

  const hasSearchObject = search && Object.keys(search).length > 0
  const hasStageElements = hasSearchObject && stageElements.isFetching !== true
  const hasSearchResults = hasStageElements && search.results

  return hasSearchResults ? search.results : undefined
}



// WEBPACK FOOTER //
// ./src/components/functions.js